<div class="hero-content">
  <div class="background-content {{ loading ? 'loading' : '' }}">
    <img
      class="background-image"
      [ngSrc]="heroImageSig()"
      placeholder
      priority
      fill="true"
      sizes="(max-width:768px) 90vw, 70vw"
      [alt]="movie()?.title + ' hero image'"
    />

    @if (embed() && hasTrailerSig() && playing()) {
      <ush-video
        *ngIf="movie() as _movie"
        #video
        [content]="_movie"
        (videoReady)="onEmbedVideoReady()"
        [embed]="false"
        [controls]="false"
        [mute]="muted()"
        [autoplay]="autoplay()"
        [trackingCategory]="trackingCategory"
      ></ush-video>
    }
  </div>
  <ush-loading-indicator *ngIf="loading" position="absolute"></ush-loading-indicator>
  <div class="hero-controls control-buttons">
    @if (!disableMovieInfo) {
      <div class="hero-info">
        @if (!isLoadingData()) {
          <img
            *ngIf="logoUrl && logoSizes"
            class="video-thumbnail-logo"
            [ngSrc]="logoUrl"
            [sizes]="logoSizes.sizes"
            [height]="logoSizes.height"
            [width]="logoSizes.width"
            [style]="logoSizes.style"
            priority="true"
            [alt]="'video thumbnail image of ' + movie()?.title"
          />
          <h2 *ngIf="!logoUrl">{{ titleSig() }}</h2>
        }
        <p *ngIf="releaseMessageSig() as _releaseMessage" [innerHTML]="_releaseMessage | safe: 'html'"></p>
      </div>
    }

    <div class="hero-buttons" *ngIf="showHeroButtons()">
      <p-button class="cta-button" *ngIf="ctaButtonLabel" [label]="ctaButtonLabel" (click)="onCtaClick()">
        <ng-template pTemplate="icon">
          <fa-icon *ngIf="seeMoreEnabled()" [icon]="playIcon"></fa-icon>
        </ng-template>
      </p-button>

      @if (hasMoviePageCompetitionEnabled()) {
        <p-button
          styleClass="button competition-button"
          [label]="competitionButtonLabel"
          [attr.data-translate]="'movie-template-a.menu.competition'"
          (click)="onCompetitionClick()"
        />
      }

      @if (!disableTrailer && hasTrailerSig()) {
        @if (embedVideoControls()) {
          <!-- play pause buttons -->
          <div class="play-pause-controls">
            <fa-icon (click)="onPauseButtonClick()" [icon]="pauseIcon"></fa-icon>
            @if (muted()) {
              <fa-icon (click)="unmuteVideo()" [icon]="unmuteIcon"></fa-icon>
            } @else {
              <fa-icon (click)="muteVideo()" [icon]="muteIcon"></fa-icon>
            }
          </div>
        } @else {
          <p-button
            class="trailer-button ctrl-play"
            styleClass="button trailer-button-surface"
            label="Watch trailer"
            i18n-label="@@movie-template-a.menu.watchTrailer"
            [attr.data-translate]="'movie-template-a.menu.watchTrailer'"
            (click)="onPlayTrailerClick()"
          >
            <ng-template pTemplate="icon">
              <fa-icon [icon]="playIcon"></fa-icon>
            </ng-template>
          </p-button>
        }
      }

      <!-- WATCH NOW - FULLVIDEO PARAM ///////////////////// -->
      @if (enableFullVideo()) {
        <a class="p-element trailer-button ctrl-play fullVideo-button" (click)="onPlayFullVideoClick()">
          <div
            class="p-element p-button p-component"
            style="height: 100%"
            [attr.data-translate]="'movie-template-a.menu.watchNow'"
          >
            <span i18n="@@movie-template-a.menu.watchNow" data-translate="movie-template-a.menu.watchNow"
              >Watch now</span
            >
          </div>
        </a>
      }

      @if (additionalLink()) {
        <a class="p-element trailer-button ctrl-play fullVideo-button" target="blank" [href]="additionalLink()">
          <div
            class="p-element p-button p-component"
            style="height: 100%"
            [attr.data-translate]="'movie-template-a.menu.watchExternal'"
          >
            <span i18n="@@movie-template-a.menu.watchExternal" data-translate="movie-template-a.menu.watchExternal"
              >Watch</span
            >
          </div>
        </a>
      }
      <!-- WATCH NOW - FULLVIDEO PARAM ///////////////////// -->

      @if (hasUplayerSig()) {
        <ush-uplay-button *ngIf="movie() as movie" [movie]="movie"></ush-uplay-button>
      }
    </div>
  </div>
  <ng-content selector="[hero-footer]"></ng-content>
</div>
